<script setup lang="ts">
import { ref, watch } from "vue";
const props = withDefaults(
	defineProps<{
		min?: number;
		max?: number;
		density?: "default" | "comfortable" | "compact" | "ultra-compact";
		label?: string;
		disabled?: boolean;
	}>(),
	{
		min: 0,
		max: Number.MAX_SAFE_INTEGER,
		size: "default",
		label: "",
		disabled: false,
	}
);

const internalValue = defineModel<number>({ required: true });

const displayValue = ref<number | string>(internalValue.value);

watch(internalValue, (val) => {
	displayValue.value = val;
});

function commitValue() {
	const raw = Number(displayValue.value);
	if (isNaN(raw)) {
		internalValue.value = props.min;
	} else {
		internalValue.value = Math.min(
			props.max,
			Math.max(props.min, Math.floor(raw))
		);
	}
	displayValue.value = internalValue.value;
}
</script>

<template>
	<!-- ultra compact input for tables -->
	<input
		v-if="props.density === 'ultra-compact'"
		v-model="displayValue"
		@blur="commitValue"
		@keyup.enter="commitValue"
		style="max-width: 110px; text-align: left"
		:min="props.min"
		:max="props.max"
		:disabled
	/>

	<v-text-field
		v-else
		v-model="displayValue"
		@blur="commitValue"
		@keyup.enter="commitValue"
		type="number"
		:label="props.label"
		:min="props.min"
		:max="props.max"
		:density="props.density"
		:disabled
		hide-details
	/>
</template>
